/**
 * The first 8 hex characters of a UUID — how a row, a card or a chat session
 * title names an entity that has no human label.
 *
 * Lived in `routes/_app/simops/-data/format.ts` until MeshGen needed it too
 * (ENG-1830). Hoisted rather than copied: two definitions would drift on the
 * length, and then the same mesh would read as `a1b2c3d4` in one surface and
 * `a1b2c3` in another. `-data/format.ts` re-exports it so the existing simops
 * call sites keep their import — that shim is for them, and new code should
 * import from here.
 */
export function shortId(id: string): string {
  return id.slice(0, 8);
}
